/*
 * CORPORATE GRIND - Judge.me Integration v4.0.0
 * CRO-1: When 0 reviews, hide empty stars and show "Be the first to review" CTA
 * When reviews exist, show stars + count normally
 */
(function() {
  "use strict";
  if (!window.location.pathname.includes('/products/')) return;

  function applyReviewLogic() {
    document.querySelectorAll('.cg-review-badge-wrap').forEach(function(wrap) {
      var badge = wrap.querySelector('.jdgm-prev-badge');
      var cta = wrap.querySelector('.cg-first-review-cta');
      if (!badge || !cta) return;
      
      var count = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
      if (count === 0) {
        badge.style.display = 'none';
        cta.style.display = 'inline-flex';
        cta.style.alignItems = 'center';
        cta.style.gap = '4px';
      } else {
        badge.style.display = '';
        cta.style.display = 'none';
      }
    });
  }

  function init() {
    /* Let Judge.me load normally but don't force empty badges visible */
    if (window.jdgmSettings) {
      window.jdgmSettings.hide_badge_preview_if_no_reviews = false;
    }

    /* Reload Judge.me widgets if available */
    if (window.jdgm) {
      if (window.jdgm.loadBadges) window.jdgm.loadBadges();
      if (window.jdgm.loadWidgets) window.jdgm.loadWidgets();
    }

    /* Apply our CRO-1 logic after Judge.me renders */
    setTimeout(applyReviewLogic, 800);
    setTimeout(applyReviewLogic, 2000);
    
    /* Watch for Judge.me lazy rendering */
    var observer = new MutationObserver(function() {
      applyReviewLogic();
    });
    var target = document.querySelector('.cg-review-badge-wrap');
    if (target) {
      observer.observe(target, { childList: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();
